module.exports = __webpack_public_path__ + "static/media/Q11-6.8e883ded.jpg";